import { useState } from 'react';

import { ApolloQueryResult } from '@apollo/client';
import { GetSalesInvoice, ResubmitToSageSalesInvoice } from 'types/graphql';

import { useMutation } from '@redwoodjs/web';

import { showErrorToast, showSuccessToast } from 'src/components/Toasts/toast';
import { RESUBMIT_TO_SAGE_SALES_INVOICE_MUTATION } from 'src/graphql/mutations/salesInvoiceResubmitSalesInvoice.mutation';

type UseReleaseSalesInvoiceProps = {
    id: number;
    refetchSalesInvoice: (
        variables?: Partial<GraphQLOperationVariables>
    ) => Promise<ApolloQueryResult<GetSalesInvoice>>;
};

export function useSalesInvoiceResubmitToSage({
    id,
    refetchSalesInvoice,
}: UseReleaseSalesInvoiceProps) {
    const [resubmittedSalesInvoice, setResubmittedSalesInvoice] =
        useState<ResubmitToSageSalesInvoice>();
    const [resubmitToSageSalesInvoice] = useMutation<ResubmitToSageSalesInvoice>(
        RESUBMIT_TO_SAGE_SALES_INVOICE_MUTATION,
        {
            onCompleted: (data) => {
                showSuccessToast('Invoice resubmitted to Sage successfully');
                setResubmittedSalesInvoice(data);
                refetchSalesInvoice();
            },
            onError: () => {
                showErrorToast(`Invoice unsuccessfully reprocessed`);
            },
        }
    );

    const handleResubmitToSage = () => {
        resubmitToSageSalesInvoice({
            variables: {
                id,
            },
        });
    };

    return {
        handleResubmitToSage,
        resubmittedSalesInvoice,
    };
}

export default useSalesInvoiceResubmitToSage;
